module.exports = __webpack_public_path__ + "static/portrait-3e98b73377c3470c3cf6631c91558e95.jpg";